import { render } from "./PrimaryFileInput.vue?vue&type=template&id=4bc19f23&scoped=true&ts=true"
import script from "./PrimaryFileInput.vue?vue&type=script&lang=ts"
export * from "./PrimaryFileInput.vue?vue&type=script&lang=ts"

import "./PrimaryFileInput.vue?vue&type=style&index=0&id=4bc19f23&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc19f23"]])

export default __exports__